import { firestore } from "firebase"

export const WOWZA_THREAD_LIMIT = 1500
export const WOWZA_CONNECTION_LIMIT = 500

export class WowzaStat {
  serverUptime: number = 0
  cpuIdle: number = 0
  cpuUser: number = 0
  cpuSystem: number = 0
  memoryFree: number = 0
  memoryUsed: number = 0
  heapFree: number = 0
  heapUsed: number = 0
  diskFree: number = 0
  diskUsed: number = 0
  threadCount: number = 0
  lastUpdate: firestore.Timestamp = firestore.Timestamp.fromMillis(0)
  connectionCount: number = 0

  constructor (data: any = undefined) {
    if (data === undefined) return
    if (typeof data.serverUptime === 'number') this.serverUptime = data.serverUptime
    if (typeof data.cpuIdle === 'number') this.cpuIdle = data.cpuIdle
    if (typeof data.cpuUser === 'number') this.cpuUser = data.cpuUser
    if (typeof data.cpuSystem === 'number') this.cpuSystem = data.cpuSystem
    if (typeof data.memoryFree === 'number') this.memoryFree = data.memoryFree
    if (typeof data.memoryUsed === 'number') this.memoryUsed = data.memoryUsed
    if (typeof data.heapFree === 'number') this.heapFree = data.heapFree
    if (typeof data.heapUsed === 'number') this.heapUsed = data.heapUsed
    if (typeof data.diskFree === 'number') this.diskFree = data.diskFree
    if (typeof data.diskUsed === 'number') this.diskUsed = data.diskUsed
    if (typeof data.connectionCount === 'number') this.connectionCount = data.connectionCount
    if (typeof data.lastUpdate !== 'undefined') this.lastUpdate = data.lastUpdate
    if (typeof data.threadCount === 'number') this.threadCount = data.threadCount
  }
}
